define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../shared/dataLogs", "../../models/UserContext", "./cpActions", "../../models/CPComposeNotificationModel"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, DataLogs, UserContext, CPActions, CPComposeNotificationModel) {
    "use strict";
    var CPCustomerProfiles = /** @class */ (function () {
        function CPCustomerProfiles() {
            this.canExport = ko.observable(UserContext.hasAccess("Admin,CPCustomerProfiles.Export"));
            this.userCanEditCPCustomerProfiles = ko.observable(UserContext.hasAccess("Admin,CPCustomerProfiles.Edit,CPCustomerProfiles.Delete"));
            this.userCanDeleteCPCustomerProfiles = ko.observable(UserContext.hasAccess("Admin,CPCustomerProfiles.Delete"));
            this.filterByAny = ko.observable("");
            this.notificationModel = ko.observable(new CPComposeNotificationModel());
            this.modulesLookup = [];
        }
        CPCustomerProfiles.prototype.init = function () {
            var self = this;
            $("#page-title").text("CP Customers Profiles");
            tools.ajaxGet({
                url: "/CPCustomerProfiles/GetLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.cpCustomerProfileLookupList = data.Data.lookupLists;
                    }
                    else {
                        log.error(data.Error);
                    }
                    self.cpActions = new CPActions();
                    self.cpActions.afterSuccess = function () {
                        self.cpCustomerProfileTable.refresh();
                    };
                    self.initGrid(self.cpCustomerProfileLookupList.GridStructures.CPCustomerProfilesStructure);
                    ko.applyBindings(self, document.getElementById("main-container"));
                    $("#contextLoader").hide();
                    $("#mainContext").show();
                }
            });
        };
        CPCustomerProfiles.prototype.initGrid = function (gridStructure) {
            var self = this;
            var gridId = "tblCPCustomerProfilesKendo";
            var columns = gridStructure.columns;
            //add actions column
            var actions = {
                field: "",
                width: "100px",
                template: function (dataItem) {
                    var html = "";
                    html += "<a class=\"btn btn-sm btn-yellow btn-edit\" href=\"/CPCustomerProfiles/Details/".concat(dataItem.Id, "\"><i class=\"fa fa-edit \"></i></a>");
                    if (self.userCanDeleteCPCustomerProfiles()) {
                        html += '&nbsp;<button class="btn btn-sm btn-danger btn-remove" href="#"><i class="fa fa-trash-o "></i></button>';
                    }
                    return html;
                }
            };
            columns.push(actions);
            self.cpCustomerProfileTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/CPCustomerProfiles/GetCPCustomerProfiles",
                            type: "POST",
                            data: function () {
                                var data = {};
                                if (self.filterByAny()) {
                                    data.filterText = self.filterByAny();
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model,
                    }
                },
                gridOptions: {
                    toolbar: kendo.template($("#cpcustomerprofiles-toolbar-template").html()),
                    columns: columns,
                    resizable: true,
                    reorderable: true,
                    //mobile: true,
                    scrollable: true,
                    columnMenu: true,
                    filterable: {
                        mode: "row",
                        extra: false
                    }
                },
                gridId: gridId,
                showPagerOnTop: false,
                enableExport: {
                    entityName: "CPCustomerProfile",
                    title: "CP Customer Profiles",
                    enablePdf: false
                },
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                controller: self
            };
            self.cpCustomerProfileTable.initGrid(gridOptions);
            self.filterByAny.extend({ rateLimit: 200 }).subscribe(function () {
                self.cpCustomerProfileTable.getGridData().dataSource.read();
            });
            $("#" + gridId + " tbody").on("click", ".btn-remove", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.cpActions.deleteCPCustomerProfileConfirm(data.Id, data.Name);
                event.preventDefault();
            });
        };
        CPCustomerProfiles.prototype.editCPCustomerProfile = function (id) {
            var self = this;
            self.cpActions.editCPCustomerProfile(id);
        };
        CPCustomerProfiles.prototype.composeNotification = function () {
            var self = this;
            tools.editModal({
                title: 'Compose Notification',
                buttonTitle: "Send",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    if (!self.notificationModel().NotificationKey()) {
                        tools.error("Notification Key is a required field");
                        return;
                    }
                    if (!self.notificationModel().NotificationType()) {
                        tools.error("Notification Type is a required field");
                        return;
                    }
                    if (!self.notificationModel().ButtonTitle()) {
                        tools.error("Button Title is a required field");
                        return;
                    }
                    if (!self.notificationModel().Title()) {
                        tools.error("Notification Title is a required field");
                        return;
                    }
                    var data = CKEDITOR.instances['NotificationText'].getData();
                    self.notificationModel().Text(data);
                    if (!self.notificationModel().Text()) {
                        tools.error("Notification Text is a required field");
                        return;
                    }
                    if (self.multipleModulesSelector) {
                        self.notificationModel().Modules(self.multipleModulesSelector.value());
                    }
                    $(event.currentTarget).button("loading");
                    self.sendNotification(event.currentTarget, modal);
                },
                opened: function (modal) {
                    var getModules = tools.ajaxGet({
                        url: "/CPCustomerProfiles/GetModules",
                        success: function (result) {
                            if (result.Success) {
                                self.modulesLookup = result.Data;
                            }
                            else {
                                log.error(result.Error);
                            }
                        }
                    });
                    $.when(getModules).done(function (data) {
                        self.notificationModel(new CPComposeNotificationModel());
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'cpcustomerprofile-notification-template', data: notificationModel }\"></div>");
                        ko.applyBindings(self, modal);
                        CKEDITOR.replace('NotificationText');
                        self.customerTypesDropdown = $("input[name=CustomerTypeSet]", modal).kendoDropDownList({
                            dataSource: [
                                { Text: 'All', Value: 'all' },
                                { Text: 'Beta Only', Value: 'betaOnly' },
                                { Text: 'Production Only', Value: 'productionOnly' }
                            ],
                            dataTextField: "Text",
                            dataValueField: "Value",
                            valuePrimitive: true,
                            filter: "contains",
                            change: function (e) {
                                self.notificationModel().CustomerTypeSet(e.sender.dataItem().Value);
                            },
                            popup: {
                                appendTo: $(".modal-body", modal)
                            }
                        }).data("kendoDropDownList");
                        if (self.customerTypesDropdown) {
                            self.customerTypesDropdown.value(self.notificationModel().CustomerTypeSet());
                        }
                        self.multipleModulesSelector = $("#PackageModules").kendoMultiSelect({
                            autoBind: false,
                            valuePrimitive: true,
                            filter: "contains",
                            placeholder: "Selected Modules",
                            dataTextField: "Text",
                            dataValueField: "Value",
                            autoClose: false,
                            // tagMode: "single",
                            dataSource: {
                                data: self.modulesLookup
                            },
                            dataBound: function () {
                                $(window).trigger("resize");
                            },
                            /*change(e) {
                                $(window).trigger("resize");
                                self.customersTable.getGridData().dataSource.read();
                            }*/
                        }).data("kendoMultiSelect");
                    });
                }
            });
        };
        CPCustomerProfiles.prototype.sendNotification = function (btn, modal) {
            var self = this;
            var data = tools.modelToFormData(self.notificationModel());
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/CPCustomerProfiles/SendNotification",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    $(modal).modal("hide");
                    return;
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        CPCustomerProfiles.prototype.showLogs = function () {
            if (UserContext.hasAccess("Admin")) {
                var dataLogs = new DataLogs("CPCustomerProfile");
                dataLogs.open("CPCustomerProfiles logs");
                event.preventDefault();
            }
        };
        CPCustomerProfiles.prototype.exportTo = function () {
            var self = this;
            if (self.canExport()) {
                self.cpCustomerProfileTable.exportTo();
            }
        };
        return CPCustomerProfiles;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/CPCustomerProfiles/Index")) {
            log.log("Initialize CPCustomerProfiles list");
            $(function () {
                (new CPCustomerProfiles()).init();
            });
        }
    }, 0);
    return CPCustomerProfiles;
});
//# sourceMappingURL=customerProfiles.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/customerPortalAdmin/customerProfiles.js
// module id = 308
// module chunks = 2